import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DocumentTemplateService as ComponentService } from '../document-template.service';
import { DocumentCategoryService } from '../../document-category/document-category.service';
import { AuthService } from 'src/app/services/auth.service';
import { finalize, forkJoin, map, takeUntil, Subject } from 'rxjs';
import { NotificationService } from 'src/app/services/notification.service';
import { environment } from 'src/environments/environment';
import { helper } from 'src/environments/helper';
import { CdkDrag, CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { NgClass } from '@angular/common';
import { MatButtonToggleChange } from '@angular/material/button-toggle';
import { BsDaterangepickerInlineConfig } from 'ngx-bootstrap/datepicker';

export interface OrderSignature {
	id: number;
	user_type: number;
	order: number;
	sign_type: null | number | string;
	functie: string;
	template_id: number;
	created_at: string;
	updated_at: string;
}

@Component({
	selector: 'app-document-template-signatures',
	templateUrl: './document-template-signatures.component.html',
	styleUrls: ['./document-template-signatures.component.scss'],
})
export class DocumentTemplateSignaturesComponent implements OnInit, OnDestroy {
	private unsubscribe$ = new Subject<void>();

	errorTitle: string = environment.config.customNotifications.headers.error;
	errorIcon: string = environment.config.customNotifications.icons.error;
	errorType: string = environment.config.customNotifications.icons.error;

	successTitle: string = environment.config.customNotifications.headers.success;
	successIcon: string = environment.config.customNotifications.icons.success;
	successType: string = environment.config.customNotifications.icons.success;

	helper = helper;

	token!: string;
	isLoading = false;
	isDragging = false;

	form: FormGroup = new FormGroup({
		name: new FormControl(this.data.name, [Validators.required]),
		context: new FormControl(this.data.context, [Validators.required]),
		type_id: new FormControl(this.data.type_id, [Validators.required]),
	});
	isChecked: boolean = false;
	saveClicked: boolean = false;
	functiiSelectedOrder: OrderSignature[] = [];
	functiiOperator: any = [];
	functiiLoaded: boolean = false;

	defaultParameter: { name: string; id: string } = {
		name: '--Alegeți--',
		id: '-1',
	};
	destinationToggle: string = 'toPrimarie'

	onSwitchChange(event: MatButtonToggleChange) {
		this.destinationToggle = event.value;
		this.loadDataTemplate();
	}

	manual_override: boolean = false
	doc_type: number = 1

	documentTypesTranslation: any = {
		'toPrimarie': 1,
		'toCetatean': 2
	}
	documentTypesTranslationReverse: any = {
		1: 'toPrimarie',
		2: 'toCetatean'
	}

	signatureTypes = [
		{ label: '--Alegeți--', value: '-1' },
		{ label: 'Semnare', value: 1 },
		{ label: 'Aprobare', value: 2 },
		// { label: 'Confirmare', value: 3 }, // doar la autorizari comerciale azi
	];

	constructor(
		@Inject(MAT_DIALOG_DATA)
		public data: any,
		private dialogRef: MatDialogRef<DocumentTemplateSignaturesComponent>,
		private componentService: ComponentService,
		private notificationService: NotificationService,
		private authService: AuthService,
		private documentCategoryService: DocumentCategoryService
	) {
		this.processToken();

		if (typeof this.data.manual_override !== 'undefined') {
			this.manual_override = this.data.manual_override

			this.destinationToggle = this.documentTypesTranslationReverse[this.data.doc_type]
			this.doc_type = this.data.doc_type
			console.log('doc_type', this.doc_type);
			console.log('this.manual_override', this.manual_override);
			console.log('this.data.id', this.data.id);
			console.log('destinationToggle', this.destinationToggle)
		}

	}

	ngOnInit(): void {
		this.loadDataTemplate();
	}

	ngOnDestroy() {
		this.unsubscribe$.next();
		this.unsubscribe$.complete();
	}

	loadDataTemplate() {
		this.isLoading = true;
		let doc_type = this.destinationToggle === 'toPrimarie' ? 1 : 2;

		const functiiOperator$ = this.componentService
			.getFunctiiUserActiveList()
			.pipe(takeUntil(this.unsubscribe$));

		const signaturesOperator$ = this.componentService
			.signaturesTemplateOperatorListIds(this.data.id, doc_type, this.manual_override)
			.pipe(
				takeUntil(this.unsubscribe$),
				map((res: any) => res.data)
			);

		forkJoin({ functiiOperator$, signaturesOperator$ })
			.pipe(
				takeUntil(this.unsubscribe$),
				map(({ functiiOperator$, signaturesOperator$ }) => {
					this.functiiSelectedOrder = signaturesOperator$.order_signatures;
					this.functiiOperator = functiiOperator$.map((functieOp: any) => ({
						...functieOp,
						checked: signaturesOperator$.ids.includes(functieOp.id),
					}));
				}),
				finalize(() => {
					this.isLoading = false;
				})
			)
			.subscribe();
	}

	closeDialog() {
		this.dialogRef?.close({
			success: false,
		});
	}

	save() {

		this.dialogRef?.close({
			success: true,
		});
	}

	processToken() {
		const tokenObj = this.authService.returnTokenUser();
		tokenObj.then((token) => {
			this.token = token;
			this.componentService.setToken(token);
		});
	}

	updateSignaturesTemplateDocument(event: any) {
		event.stopPropagation();

		this.isLoading = true;
		let doc_type = this.destinationToggle === 'toPrimarie' ? 1 : 2;
		this.componentService
			.updateSignaturesTemplateOperatorIds(this.data.id, {
				doc_type: doc_type,
				user_type_ids: this.functiiOperator
					.filter((fo: any) => fo.checked)
					.map((fo: any) => fo.id),
			}, this.manual_override)
			.subscribe({
				next: () => {
					this.loadDataTemplate();
					this.saveClicked = true;
				},
				error: (err: any) => {
					this.isLoading = false;
					let msg;
					try {
						// try to catch the message from server
						msg = err.error.errors.message[0];
					} catch (error) {
						// controll output message
						msg = helper.dialogConfig.generalMessages.error;
					}
					this.notificationService.warningSwal(
						helper.dialogConfig.headers.errorAtentie,
						msg,
						this.errorIcon
					);
				},
			});
	}

	drop(event: CdkDragDrop<OrderSignature[]>): void {
		moveItemInArray(
			this.functiiSelectedOrder,
			event.previousIndex,
			event.currentIndex
		);

		// Update the order property of the reordered elements
		this.functiiSelectedOrder.forEach((item, index) => (item.order = index));
	}

	saveOrder(event: any) {
		event.stopPropagation();

		this.isLoading = true;
		this.componentService
			.updateSignatures(this.functiiSelectedOrder, this.manual_override)
			.subscribe({
				next: () => {
					console.log('saveOrder');
					this.loadDataTemplate();
				},
				error: (err: any) => {
					this.isLoading = false;
					let msg;
					try {
						// try to catch the message from server
						msg = err.error.errors.message[0];
					} catch (error) {
						// controll output message
						msg = helper.dialogConfig.generalMessages.error;
					}
					this.notificationService.warningSwal(
						helper.dialogConfig.headers.errorAtentie,
						msg,
						this.errorIcon
					);
				},
			});
	}
}
